/*
Dataset stats loader — mirrors Android DatasetStats.kt.
Single tiny JSON object with the dataset totals used in the Arboretum header
("X / 909 espèces") and on the Profile screen.
*/

import { fetchJson } from './fetchJson'

const kAssetPath = '/data/dataset-stats.json'  // canonical location served by the SW

export interface DatasetStats
{
	totalArbres: number
	totalEspeces: number
	totalRemarquables: number
	// ISO 8601 UTC string ("2026-05-09T11:30:04Z") stamped at build time
	// by tools/build_dataset.py. Optional for forward-compat with old
	// snapshots that pre-date the field — callers must handle absence.
	generatedAt?: string
}

let fStats: DatasetStats | null = null  // memoized stats, null until first load

/*
Ensure dataset-stats is loaded. Idempotent. Throws with context on fetch
or JSON failure; caller decides whether to surface a degraded UI.
*/
export async function ensureDatasetStats(): Promise<DatasetStats>
{
	if (fStats) return fStats
	fStats = await fetchJson<DatasetStats>(kAssetPath)
	return fStats
}
